package one.healthium.update_food_preferences.domain.models

data class FoodPreferenceCategoryOptions(
    val id: String,
    val options: List<FoodPreferenceOption>
)
